import React, {useContext, useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Routes, Route } from 'react-router-dom';

import { MainTabPanelIndex } from '../../model/constants';

import SummaryMainTabPanel from './summaryPanels/SummaryMainTabPanel'
import SummaryBDTabPanel from './summaryPanels/SummaryBDTabPanel'
import SummaryHistoryTabPanel from './summaryPanels/SummaryHistoryTabPanel'
import SummaryChatTabPanel from './summaryPanels/SummaryChatTabPanel'
import SummaryLogsTabPanel from './summaryPanels/SummaryLogsTabPanel'
import SummarySendToFtpServerInfoTabPanel from './summaryPanels/SummarySendToFtpServerInfoTabPanel'

import { CurrentEquipContext } from '../../context/currentEquip-context';
import { AppContext } from '../../context/app-context';

const useStyles = makeStyles((theme) => ({
  root: {
    
  },
}));

export default function SummaryTab(props) {
  console.log("render SummaryTab");

  const classes = useStyles();
  const [appState, appDispatch] = useContext(AppContext);
  const [currEquipState, currEquipDispatch] = useContext(CurrentEquipContext);
  const [currActive, setCurrActive] = useState(false);

  const equipName = currEquipState?.equipInfo;
  
  useEffect(() => 
  { 
    setCurrActive(currEquipState?.locationInfo?.IsActive)
  }, [currEquipState?.locationInfo?.IsActive]);

  return (
    <div name="divSummaryTab">
      <Routes>
        <Route path="main" element={<SummaryMainTabPanel/>}/>
        <Route path="BD" element={<SummaryBDTabPanel equipName={equipName}/>} />  
        <Route path="history" element={<SummaryHistoryTabPanel equipName={equipName}/>}/>
        <Route path="chat" element={<SummaryChatTabPanel equipName={equipName}/>} />  
        <Route path="logs" element={<SummaryLogsTabPanel equipName={equipName}/>}/>
        <Route path="sendToFtp" element={<SummarySendToFtpServerInfoTabPanel equipName={equipName} currActive={currActive}/>} />  

    </Routes>
    </div>
  );
}